export const numberWithDelimiter = number => {
  const formatter = new Intl.NumberFormat('en-US', {});
  return formatter.format(number);
};

export const dollars = value => {
  return `$${numberWithDelimiter(parseInt(value))}`;
};
